;; This Source Code Form is subject to the terms of the Mozilla Public
;; License, v. 2.0. If a copy of the MPL was not distributed with this
;; file, You can obtain one at http://mozilla.org/MPL/2.0/

(ns renolit-roofing-service.routes
  (:require [dev.gethop.session.re-frame.cognito.token :as cognito.token]
            [re-frame.core :as rf]
            [reitit.frontend :as reitit.fr]
            [reitit.frontend.controllers :as reitit.frc]
            [reitit.frontend.easy :as reitit.fre]
            [renolit-roofing-service.navigation :as nav]
            [renolit-roofing-service.shared.util.malli-coercion :as util.malli-coercion]
            [renolit-roofing-service.view.rae-home :as view.rae-home]
            [renolit-roofing-service.view.installer-home :as view.installer-home]
            [renolit-roofing-service.view.installer-service-detail :as view.installer-service-detail]
            [renolit-roofing-service.view.installer-review-wp-detail :as view.installer-review-wp-detail]
            [renolit-roofing-service.view.installer-service-information :as view.installer-service-information]
            [renolit-roofing-service.view.laboratory-home :as view.laboratory-home]
            [renolit-roofing-service.view.laboratory-report :as view.laboratory-report]
            [renolit-roofing-service.view.laboratory-report-summary :as view.laboratory-report-summary]
            [renolit-roofing-service.view.laboratory-sample-analysis :as view.laboratory-sample-analysis]
            [renolit-roofing-service.view.not-found :as view.not-found]
            [renolit-roofing-service.view.project-list :as view.project-list]
            [renolit-roofing-service.view.project-view :as view.project-view]
            [renolit-roofing-service.view.service-add :as view.service-add]
            [renolit-roofing-service.view.service-view :as view.service-view]
            [renolit-roofing-service.view.session.code-verify :as session.code-verify]
            [renolit-roofing-service.view.session.forgot-password :as session.forgot-password]
            [renolit-roofing-service.view.session.login :as session.login]
            [renolit-roofing-service.view.session.register :as session.register]
            [renolit-roofing-service.view.session.register-details :as view.register-details]))

(rf/reg-event-db
 ::apply-nav-route
 (fn [db [_ new-match]]
   (let [old-match (:current-route db)
         controllers (reitit.frc/apply-controllers (:controllers old-match) new-match)]
     (assoc db :current-route (assoc new-match :controllers controllers)))))

(rf/reg-event-fx
 ::navigated
 [(rf/inject-cofx ::cognito.token/session)]
 (fn [{:keys [db session]} [_ new-match]]
   (let [jwt (get-in session [:id-token :jwt])             ;; means logged in
         user (:user db)                                   ;; means user profile completed
         auth-req? (get-in new-match [:data :auth-req?])   ;; means protected page which requires jwt and user
         route-name (get-in new-match [:data :name])]
     (cond
       (and (not jwt) (or auth-req? (= route-name (:name view.register-details/route-config))))
       {:dispatch [::nav/push-state (:name session.login/route-config)]}

       (and jwt (not user) (not= route-name (:name view.register-details/route-config)))
       {:dispatch [::nav/push-state (:name view.register-details/route-config)]}

       (and jwt user (= route-name (:name view.rae-home/route-config)) (= :installer (:role user)))
       {:dispatch [::nav/push-state (:name view.installer-home/route-config)]}

       (and jwt user (= route-name (:name view.rae-home/route-config)) (= :laboratory (:role user)))
       {:dispatch [::nav/push-state (:name view.laboratory-home/route-config)]}

       :else
       {:dispatch [::apply-nav-route new-match]}))))

(def routes
  ["/"
   [""
    view.rae-home/route-config]
   ["installer"
    view.installer-home/route-config]
   ["installer/service/:id"
    view.installer-service-detail/route-config]
   ["installer/service/:id/information"
    view.installer-service-information/route-config]
   ["installer/service/:id/review/:wp"
    view.installer-review-wp-detail/route-config]
   ["projects"
    view.project-list/route-config]
   ["project/:project-id"
    view.project-view/route-config]
   ["projects/:project-id/services/add"
    view.service-add/route-config]
   ["service/:service-id"
    view.service-view/route-config]
   ["laboratory"
    view.laboratory-home/route-config]
   ["laboratory/service/:id"
    view.laboratory-sample-analysis/route-config]
   ["laboratory/service/:id/report"
    view.laboratory-report/route-config]
   ["laboratory/service/:id/report/summary"
    view.laboratory-report-summary/route-config]
   ["not-found"
    view.not-found/route-config]
   ["login"
    session.login/route-config]
   ["register"
    session.register/route-config]
   ["register-details"
    view.register-details/route-config]
   ["code-verify"
    session.code-verify/route-config]
   ["forgot-password"
    session.forgot-password/route-config]])

(defn on-navigate
  [new-match]
  (if new-match
    (rf/dispatch [::navigated new-match])
    (rf/dispatch [::nav/push-state (:name view.not-found/route-config)])))

(def router
  (reitit.fr/router
   routes
   {:data {:coercion util.malli-coercion/custom-reitit-malli-coercer}}))

(rf/reg-fx
 :do-init-routes
 (fn [_]
   (reitit.fre/start!
    router
    on-navigate
    {:use-fragment false
     :on-coercion-error (fn [_ _] (js/alert "Coercion error!"))})))

(rf/reg-event-fx
 ::init-routes
 (fn [_ _]
   {:fx [[:do-init-routes]]}))
